<template>
  <LineChart :height="300" :chartData="data" :options="options"/>
</template>

<script>
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);
import {LineChart} from 'vue-chart-3';

export default {
  name: "ChamadosAbertosFechados",
  components: {
    LineChart
  },
  props: ['data'],
  setup() {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Chamados',
          align: 'start',
          font: {
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
        },
        subtitle: {
          display: true,
          text: 'Abertos / Fechados',
          align: 'start'
        }
      },
    };
    return {options};
  }
}
</script>

<style>

</style>